/* Pluguins
==================== */
import "@babel/polyfill"; // IE11でES6を動かすのに必要
import "svgxuse"; // IE11でsvgスプライトを使うのに必要
import "picturefill"; // IE11でpictureを使うのに必要
import "what-input"; //キーボード操作以外でoutlineを表示させない為に必要
import lazySizes from "lazysizes"; // 画像の遅延読み込みに使用
// import Vue from "vue"; //vue本体 どこでも呼び出せます
import Breakpoints from "../@scss/@foundation/_@variables.scss";
import "intersection-observer"; // IE11でpintersection-observerを使うのに必要
import Bound from "bounds.js"; //スクロールイベントの奴

/* Modules
==================== */
import UserAgent from "./modules/UserAgent";
UserAgent();

//ハンバーガーのjs
import menu from "./modules/menu";
menu();

// スムーズスクロールのjs
import SmoothScroll from "./modules/SmoothScroll";
SmoothScroll();

// スムーズスクロールのjs
import More from "./modules/More";
More();

//TOPのスライド
import TopSwiper from "./modules/TopSwiper";
TopSwiper();

//LDKリフォームのスライド
import LdkSwiper from "./modules/LdkSwiper";
LdkSwiper();

//下層ページの画像gallery
import ImgGallery from "./modules/ImgGallery";
ImgGallery();

// import thumbSlide from "./modules/thumbSlide";
// thumbSlide();

/* Script
==================== */
lazySizes.cfg.lazyClass = `lazy`;
lazySizes.cfg.loadedClass = `is-loaded`;
document.addEventListener(`lazybeforeunveil`, event => {
  const bg = event.target.dataset.bg;
  if (bg) {
    event.target.style.backgroundImage = `url(${bg})`;
  }
});
// コンソールログはプロダクションモードでは取り除かれるので、自由に使ってもらって構いません。

import gnavOpen from "./modules/gnavOpen";
gnavOpen();

import toTopBtn from "./modules/toTopBtn";
toTopBtn();

import boundsSticky from "./modules/boundsSticky";
boundsSticky();

import _gallery from "./modules/gallery";
_gallery();

// IEでposition:stickyが動くように
import Stickyfill from "stickyfilljs";
const elements = document.querySelectorAll(".sticky");
Stickyfill.add(elements);

// IEでページ読み込み時にtransitionが動く不具合対応
import forIE from "./modules/forIE";
forIE();
